import React, { useEffect, useState } from 'react'
import { Redirect, useLocation, useHistory, useParams } from 'react-router-dom'
import {
  useErrorService,
  surveyType,
  getAssessmentCompareRoutePrefix,
  WisdomComparisonReport,
  PrintableArea,
} from '@abroad/components'
import { Helmet } from 'react-helmet'
import { useUserFirstName } from '../components'
import API from '../utils/API'
import moment from 'moment-timezone'

export const UserCompareAssessment = () => {
  const { search } = useLocation()
  const history = useHistory()
  const query = new URLSearchParams(search)
  const querySurveyType = query.get('surveyType') || surveyType.AWARENESS
  const params = query.getAll('survey')
  const { userId } = useParams()
  const isWisdomCompare = querySurveyType === surveyType.WISDOM

  const Error = useErrorService()
  const [isLoading, setIsLoading] = useState(true)
  const [comparisonData, setComparisonData] = useState([])
  const userFirstName = useUserFirstName(userId)

  useEffect(() => {
    if (!isWisdomCompare) {
      return
    }

    const getComparion = async () => {
      try {
        const { data } = await API.CoachAPI.coachClient.getUserComparisonReport(
          userId,
          {
            surveyIds: params,
          },
          querySurveyType,
        )
        setComparisonData(data)
        setIsLoading(false)
      } catch (e) {
        if (
          e?.code === 'ValidationError' ||
          e?.code === 'resource_not_found' ||
          e?.code === 'not_found'
        ) {
          history.replace('/404')
        } else if (e?.code === 'upgrade_plan') {
          setIsLoading(false)
        } else {
          setIsLoading(false)
          Error.showError(e)
        }
      }
    }
    if (params.length === 2) {
      getComparion()
    } else {
      history.replace('/admin/home')
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isWisdomCompare])

  if (!isWisdomCompare) {
    const routePrefix = getAssessmentCompareRoutePrefix(querySurveyType)
    const clientId = query.get('clientId') || userId
    if (!query.get('clientId') && clientId) {
      query.set('clientId', clientId)
    }
    return (
      <Redirect to={`/${routePrefix}/comparison-report?${query.toString()}`} />
    )
  }

  const renderHelmet = () => {
    return (
      <Helmet>
        <title>{`${userFirstName} Compare Results | Abroad`}</title>
        <meta
          name='title'
          content={`${userFirstName} Compare Results | Abroad`}
        />
        <meta
          property='og:title'
          content={`${userFirstName} Compare Results | Abroad`}
        />
        <meta
          property='twitter:title'
          content={`${userFirstName} Compare Results | Abroad`}
        />
        <link
          rel='canonical'
          href={`${process.env.REACT_APP_DOMAIN}/user/${userId}/comparison_report`}
        />
        <meta
          property='og:url'
          content={`${process.env.REACT_APP_DOMAIN}/user/${userId}/comparison_report`}
        />
        <meta
          property='twitter:url'
          content={`${process.env.REACT_APP_DOMAIN}/user/${userId}/comparison_report`}
        />
      </Helmet>
    )
  }

  return (
    <>
      {renderHelmet()}
      <main>
        <WisdomComparisonReport
          preDate={moment(comparisonData[0]?.submittedAt).format(
            'MMM DD, YYYY',
          )}
          postDate={moment(comparisonData[1]?.submittedAt).format(
            'MMM DD, YYYY',
          )}
          isLoading={isLoading}
          comparisonData={comparisonData}
          header={() => 'Compare Results'}
          showGoBackButton={false}
          isRenderFromOP={true}
        />
      </main>
      <PrintableArea printSelector='main' />
    </>
  )
}

export default UserCompareAssessment
